import React, { useRef } from "react";
import { Button, Box, CircularProgress } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel, Select, MenuItem } from "@mui/material";
import userService from "../../services/userService";

const UserAddModal = (props) => {
	
	const firstname = useRef(null);
	const lastname = useRef(null);
	const email = useRef(null);
	const access_level = useRef(null);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		const user = {
			firstname: firstname.current.value,
			lastname: lastname.current.value,
			email: email.current.value,
			access_level: access_level.current.value
		};
		props.onSubmit(user);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose()
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Add Company
			</DialogTitle>
			<DialogContent>
				{ props.loading &&
					<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
						<CircularProgress sx={{ margin: "auto", textAlign: "center" }} />
					</Box>
				}
				{ !props.loading &&
					<form onSubmit={handleSubmitForm} autoComplete="off">
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="firstname">Firstname</InputLabel>
							<Input
								inputRef={firstname}
								id="firstname"
								type="firstname"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="lastname">Lastname</InputLabel>
							<Input
								inputRef={lastname}
								id="lastname"
								type="lastname"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="email">Email</InputLabel>
							<Input
								inputRef={email}
								id="new_email"
								type="email"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="access_level" sx={{ backgroundColor: "background.inputLabel" }}>
								Access Level
							</InputLabel>
							<Select
								inputRef={access_level}
								id="access_level"
								autoComplete="off"
								defaultValue="3"
							>
								{(userService.AccessLevel() === 1) &&
									<MenuItem value={1}>Super Admin</MenuItem>
								}
								<MenuItem value={2}>Company Admin</MenuItem>
								<MenuItem value={3} selected>Company User</MenuItem>
							</Select>
						</FormControl>
					</form>
				}
			</DialogContent>
			{ !props.loading &&
				<DialogActions>
					<Button onClick={handleCancel}>Cancel</Button>
					<Button onClick={handleSubmit} autoFocus>Submit</Button>
				</DialogActions>
			}
		</Dialog>
	);
};

export default UserAddModal;